'use strict';
var dataLayer = window.dataLayer;
var utils = require('plugin_jac/util');
/**
 * to check the user is logged in or not
 * @return {boolean} - whether user is logged in or not
 */
function isRegisteredUser() {
	var isAuthenticated = false;
	for (var i = 0; i < dataLayer.length; i++) {
		if (dataLayer[i].event === 'userDetails') {
			isAuthenticated = dataLayer[i].isLoggedIn.toLowerCase() === 'yes';
			break;
		}
	}
	return isAuthenticated;
}

function checkoutSMSSignupEvents(){
	if ($('#smsOptin').length && $('#smsOptin').is(':checked')) {
		checkoutClickEvent('SMS Order Signup','Payment Details');
	}
}

// function isVisible($el) {
// 	let docViewTop = $(window).scrollTop();
// 	let docViewBottom = docViewTop + $(window).height();
// 	let elTop = $el.offset().top;
// 	let elBottom = elTop + $el.height();
// 	return((elBottom <= docViewBottom) && (elTop >= docViewTop));
// }

/**
 * push header navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function headerNavigationEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Header Navigation Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push header navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function charmPromoProgressEvent(param) {
	if (param) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'charm_promo_event',
			eventAction: 'Progress Bar ' + param,
			eventLabel: 'Progress Bar'
		});
	}
}

/**
 * push header navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function charmPromoMessageEvent(param) {
	if (param) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'charm_promo_event',
			eventAction: 'Message',
			eventLabel: param
		});
	}
}

/**
 * push header navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function accountAnalyticsEvent(eventAction,eventLabel) {
	if (eventAction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Account',
			eventAction: eventAction,
			eventLabel: eventLabel
		});
	}
}
/**
 * push footer navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function footerNavigationEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Footer Navigation Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push homepage click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function homePageEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Homepage Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}


/**
 * push homepage click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function ourStoryEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Our Story Event',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push contact us click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */

function contactUsEvent(eventaction, eventlabel) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Contact Us',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push homepage click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function trunkEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: '70 Years Event',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push DFA click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function dfaEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Designs From Our Archives',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push PLP click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function plpEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'PLP Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push PLP click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function cyoPlpEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'CYO Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
/**
 * push filters click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function filtersClickEvent(eventlabel, eventaction) {
	if (eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: $('.cyo-page').length > 0 ? 'CYO Filters' : 'Filters',
			eventAction: eventaction,
			eventLabel: eventlabel === undefined ? '' : eventlabel
		});
	}
}
/**
 * push Cyo Filter click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function cyoFiltersEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'CYO Filters',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
/**
 * push search click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function searchClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: $('.cyo-page').length > 0 ? 'CYO Search' : 'Search',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push search click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function customerServiceClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Customer Service',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

function cyoRemoveEcommerceEvent(eventaction, eventlabel) {
	if (dataLayer && eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Ecommerce',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

function cyoEditEcommerceEvent(eventAction, eventLabel) {
	if (dataLayer && eventLabel && eventAction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Cart',
			eventAction: eventAction,
			eventLabel: eventLabel
		});
	}
}

/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function pdpClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'PDP Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

function cartClickAnalyticsEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Cart Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function shopTheLookEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Shop the Look',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**

 * push checkout click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function checkoutClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Checkout Funnel',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
/**
 * push Cyo PDP click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function cyoPdpClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'CYO PDP Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
/**
 * push Cyo PDP click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function categorizePDPClickEvent(eventlabel, eventaction) {
	var isCYO = $('.product-wrapper').length > 0 && $('.product-wrapper').hasClass('cyo-page');
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: (isCYO) ? 'CYO PDP Click' : 'PDP Click',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function miniCartClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Mini Cart',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function itemAddedCartClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Item Added Modal',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function ecommerceClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Ecommerce',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}

/**
 * push pdp click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function cartClickEvent(eventlabel, eventaction) {
	if (eventlabel && eventaction) {
		dataLayer.push({
			event: 'GAevent',
			eventCategory: 'Cart',
			eventAction: eventaction,
			eventLabel: eventlabel
		});
	}
}
function checkoutImpressionClickEvent(ecommerce) {
	if (ecommerce) {
		dataLayer.push({
			event: 'checkout',
			ecommerce: ecommerce
		});
	}
}
//Function to get selected shipping method
function getSelectedShippingMethod(){
	var shippingMethod;
	var shipmentType = $('#checkout-main').data('shipmenttype');
	var selectShippingMethodEle = $('.shippingMethod_rdio:checked');
	if(shipmentType && shipmentType != 'instore'){
		shippingMethod = (selectShippingMethodEle && selectShippingMethodEle.length > 0) ? selectShippingMethodEle.data('details') : 'Not Selected';
	}else{
		shippingMethod = 'pickUpStore';
	}
	return shippingMethod;
}

function checkoutGlobalPageDetalsEvent(pageString) {
	if (pageString) {
		dataLayer.push({
			event: 'pageDetails',
			pageName: pageString
		});
	}
}

// function cyoPageClickEvent(eventlabel, eventaction) {
// 	if (eventlabel && eventaction) {
// 		dataLayer.push({
// 			event: 'GAevent',
// 			eventCategory: 'CYO Page',
// 			eventAction: eventaction,
// 			eventLabel: eventlabel
// 		});
// 	}
// }

/**
 * push storelocator click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function storeLocatorEvent(eventObj) {
	if (eventObj.eventAction) {
		var eventCategory = '';
		var eventWindow = ($('.store-locator-container') && $('.store-locator-container').hasClass('storelocmodal')) ? 'Store Locator Modal' : 'Store Locator Page';		
		eventCategory = (eventObj.CheckDetailModal && $('#storeDeatilsModal:visible').length > 0) ? 'Store Details Modal' : eventWindow;
		dataLayer.push({
			event: 'GAevent',
			eventCategory : eventCategory,
			eventAction: eventObj.eventAction,
			eventLabel: eventObj.eventLabel
		});
	}
}

/**
 * push updated user email, hashedEmail to data layer
 * @param {string} email - User email
 */
function emailCaptureEvent(email,userHashedEmail) {
	if(email && userHashedEmail){
		for (var i = 0; i < dataLayer.length; i++) {
			if (dataLayer[i].event === 'userDetails') {
				dataLayer[i].userEmail = email;
				dataLayer[i].userHashedEmail = userHashedEmail;
				break;
			}
		}
	}
}

var events = {
	all: function () {
		$(document).ready(function () {
			$(document).on('click', '.minicart-link', function () {
				var eventaction = isRegisteredUser() ? 'Authenticated User Details' : 'Non Authenticated User Details';
				headerNavigationEvent($.trim($(this).find('.cart-label').text()), eventaction);
			});
			$(document).on('click', '.link-track', function () {
				var eventaction = isRegisteredUser() ? 'Authenticated User Details' : 'Non Authenticated User Details';
				let IsUserSelectedStore = $(this).find('.user-message') && $(this).find('.user-message').hasClass('user-selected-store') ? true : false;
				let eventLabel = IsUserSelectedStore ? 'My Store' : $.trim($(this).find('.user-message').text());
				headerNavigationEvent(eventLabel, eventaction);
			});
			$(document).on('click', '.account-link-track', function () {
				var eventaction = isRegisteredUser() ? 'Authenticated User Details' : 'Non Authenticated User Details';
				headerNavigationEvent('My Account', eventaction);
			});
			$(document).on('click', '.wishlist-link-track', function () {
				var eventaction = isRegisteredUser() ? 'Authenticated User Details' : 'Non Authenticated User Details';
				headerNavigationEvent($.trim($(this).text()), eventaction);
			});
			$(document).on('click', '.logo-home', function () {
				headerNavigationEvent(window.location.pathname, 'Main Logo');
			});
			$(document).on('click', '.l1-menu-link', function () {
				headerNavigationEvent($.trim($(this).text()), 'Category Menu');
			});

			$(document).on('click', '.embeddedServiceHelpButton .helpButton', function() {
				var pageInfo = (dataLayer && dataLayer.length > 0 ) ? dataLayer.find(el => el.event == 'pageDetails') : '';
				footerNavigationEvent((pageInfo ? pageInfo.pageName : pageInfo), 'Open Chat');
			});

			$('body').on('cyo:removecyoset', function (e, data) {
				cyoRemoveEcommerceEvent(data.eventAction, data.eventLabel);
			});
			$('body').on('cyo:handorLaserClick', function (e, data) {
				cyoPlpEvent(data.eventLabel, data.eventAction);
			});
			$('body').on('cyo:cartactions', function (e, data) {
				cyoEditEcommerceEvent(data.action, data.label);
			});

			$(document).on('productTile:trackDynamicImpression', function (e, data) {
				let gtmData = data.gtmData;
				if (gtmData) {
					dataLayer.push({
						event: 'productImpression',
						ecommerce: {
							impressions: [data.gtmData]
						}
					});
				}
			});

			$('body').on('click', '.gtm-checkout-btn', function () {
				if (dataLayer && ($(this).parents('div.minicart').find('.cyo-set-details').length || $(this).parents('.cart.cart-page').find('.cyo-set-details').length)) {
					dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'Mini Cart',
						eventAction: 'Proceed to Checkout',
						eventLabel: 'Cyo set'
					});
					var cyoSetDetails = $(this).parents('div.minicart').find('.cyo-set-details');
					if (!cyoSetDetails.length) {
						cyoSetDetails = $(this).parents('.cart.cart-page').find('.cyo-set-details');
					}
					cyoSetDetails.each(function () {
						var cyoData = $(this).data('charmdata');
						if (cyoData && cyoData.length) {
							for (let index = 0; index < cyoData.length; index++) {
								let element = cyoData[index];
								if (element && element.name) {
									dataLayer.push({
										event: 'GAEvent',
										eventCategory: 'Mini Cart',
										eventAction: 'Proceed to Checkout',
										eventLabel: 'Cyo - ' + element.name
									});
								}
							}
						}
					});
				}
			});
			$('body').on('cyo:ecommerceremove', function (e, data) {
				var gtmData = data.gtmArray;
				if (gtmData && dataLayer) {
					dataLayer.push({
						event: 'removeFromCart',
						ecommerce: {
							remove: {
								products: [gtmData]
							}
						}
					});
				}
			});
			$(document).on('click', '.promo-banner-click', function () {
				headerNavigationEvent($.trim($(this).parents().find('.promo-label').text()), 'Banner');
			});
			$(document).on('click', '.sub-category-menu-link', function () {
				headerNavigationEvent($.trim($(this).text()), $.trim($(this).closest('.nav-item.show').find('.l1-menu-link:first-child').text()));
			});
			$(document).on('click', '.navigation-banner-click', function () {
				headerNavigationEvent($.trim($(this).find('.banner-label').text()), 'Banner');
			});
			$(document).on('click', '.footer-middle-link', function () {
				footerNavigationEvent($.trim($(this).text()), $.trim($(this).closest('.dropdown-container').find('a.dropdown-toggle').text()));
			});
			$(document).on('click', '.social-link', function () {
				footerNavigationEvent($.trim($(this).attr('data-analytics-label')), 'Social Link');
			});
			$(document).on('click', '.last-section', function () {
				footerNavigationEvent($.trim($(this).text()), 'Last Section');
			});
			$(document).on('click', '.privacy-policy', function () {
				footerNavigationEvent($.trim($(this).text()), 'Email Subscription');
			});
			$(document).on('emailSubscribe:errorAnalytics', function () {
				footerNavigationEvent('Error', 'Email Subscription');
			});
			$(document).on('emailSubscribe:success', function () {
				footerNavigationEvent('Success', 'Email Subscription');
			});
			$(document).on('click', '.footer-top-link', function () {
				footerNavigationEvent((window.location.pathname), 'Back to top');
			});
			$(document).on('click', '.plpClickCarousel', function () {
				if ($(this).parents('.cyo-plp-details').length) {
					cyoFiltersEvent($.trim($(this).text()), 'By Theme');
				} else {
					plpEvent($.trim($(this).text()), 'Visual Navigation');
				}
			});

			$(document).on('click','.cyo-page .gtm-clear-btn:visible', function(){
				dataLayer.push({
					event: 'GAevent',
					eventCategory: 'CYO Filters',
					eventAction: 'Clear All',
					eventLabel: ''
				});
			});


			$(document).on('click', '.plpCarousel a', function () {
				var eventLabel = ($(this).children('img').length > 0) ? $.trim($(this).siblings('p').children('a').text()) : $.trim($(this).text());
				if(eventLabel){
					plpEvent(eventLabel, $.trim($('.plpWrapper > p:first').text()));
				}
			});
			$(document).on('click', '.plpCarousel .slick-dots button', function () {
				if ($(this).parents('.cyo-plp-details').length) {
					cyoFiltersEvent('Next Filters', 'By Theme');
				}
				else {
					plpEvent('Next Products', 'Visual Navigation');
				}
			});
			$(document).on('fliter:trackingViewmoreAnalytics', function (e, data) {
				filtersClickEvent(data.dataAction, data.dataLabel);
			});
			$(document).on('filter:trackingFilterAnalytics', function (e, data) {
				if ($(this).find('.cyo-refinement-bar').length) {
					var filterStatusLabel = data.filterStatus ? (data.filterStatus + ' - ') : '';
					cyoFiltersEvent(data.filterName, filterStatusLabel + data.filterCategory);
				} else {
					filtersClickEvent(data.filterName, data.filterCategory);
				}
			});
			$(document).on('sort:trackingSortAnalytics', function (e, data) {
				if ($(this).find('.cyo-filter-bar').length) {
					cyoFiltersEvent(data.sortOption, 'Sort By');
				} else {
					filtersClickEvent(data.sortOption, 'Sort By');
				}
			});
			$(document).on('click', '.product-click-track', function (e) {	
				var newHref = $(this).attr('href');
				var carouselTitle = '';
				var isRecommendationItem = $(this).closest('.recommendations').length > 0 ? true : false;
				let gtmData = JSON.parse($(this).attr('data-gtm-data'));

				if(isRecommendationItem) {
					carouselTitle = $(this).closest('.recommendations').find('.gtm-text').text().trim();
				}				
				
				// Regular PLP List name
				var analyticsCategory = $('#categoryName').val();
				if ($(this).closest('.cyo-plp-details').length > 0) {
					// CYO PLP List name
					analyticsCategory = $(this).closest('.search-results').find('#categoryName').val();
				}

				let productId = gtmData.id;
				if(productId && productId.indexOf('STL') > -1) {
					gtmData.shopTheLookID = productId;
				}

				let list = isRecommendationItem ? carouselTitle : analyticsCategory;

				if (gtmData && list) {
					if(isRecommendationItem){
						var positionInSlick = $(this).closest('.slick-slide').data('slick-index');
						gtmData.position = parseInt(positionInSlick) + 1;
					}
					dataLayer.push({
						event: 'productClick',
						ecommerce: {
							click: {
								actionField: {
									list: list
								},
								products: [gtmData]
							}
						}
					});					
				}
				if(isRecommendationItem){
					e.preventDefault();
					var currentHref = $(this).attr('href');
					newHref = currentHref.replace('others', carouselTitle);
					window.location.href = newHref;
				}
			});
			

			$(document).on('wishlist:addToCart', function (e, data) {
				if (data) {
					var gtmDetails = data.gtmData;
					dataLayer.push({
						event: 'addToCart',
						cartAdditionSource : 'Wish List Page',
						ecommerce: {
							add: {
								products: gtmDetails
							}
						}
					});
				}
			});

			$(document).on('searchItem:Clicked', function (e, data) {			
				if (data.gtmInfo) {
					let gtmData = JSON.parse(data.gtmInfo);
					let productId = gtmData.id;
					if(productId && productId.indexOf('STL') > -1) {
						gtmData.shopTheLookID = productId;
					}
					dataLayer.push({
						event: 'productClick',
						ecommerce: {
							click: {
								actionField: {
									list: data.listName,
								},
								products: [gtmData]
							}
						}
					});	
				}
			});


			$(document).on('crossSell:trackDynamicImpression', function (e, data) {			
				if (data) {
					let gtmData = JSON.parse(data.gtmData);
					dataLayer.push({
						event: 'productImpression',
						ecommerce: {
							impressions: [gtmData]
						}
					});
				}
			});

			$(document).on('wishlist:trackDynamicImpression', function (e, data) {				
				if (data) {
					dataLayer.push({
						event: 'productImpression',
						ecommerce: {
							impressions: data.gtmData
						}
					});
				}
			});

			$(document).on('wishlist:ProductClick', function (e, data) {		
				if (data && data.gtmData) {
					var listName = data.gtmData[0].list;
					delete data.gtmData[0].list;
					if(data.gtmData[0].shopTheLookID){
						delete data.gtmData[0].shopTheLookID;
					}
					dataLayer.push({
						event: 'productClick',
						ecommerce: {
							click: {
								actionField:{
									list: listName
								},
								products: data.gtmData
							}
						}
					});	
				}
			});

			$(document).on('click', '.gtm-swatch-click', function () {
				var pageURL = $('.page').data('action');
				if ($(this).parents('.cyo-plp-details').length) {
					cyoPlpEvent($.trim($(this).data('display-name')), 'Swatch');
				}
				else {
					if (pageURL === 'Search-Show') {
						plpEvent($.trim($(this).data('display-name')), 'Swatch');
					}
					else if (pageURL === 'Product-Show') {
						if ($('#itemAddedFlyout').length) {
							itemAddedCartClickEvent($.trim($(this).attr('data-display-name')), 'Swatch');
						}
						else{
							pdpClickEvent($.trim($(this).data('display-name')), 'Swatch');
						}
					}else if ($('.storepage').length > 0) {
						homePageEvent($.trim($(this).data('display-name')), 'Swatch');
					}
				}
			});
			$(document).on('cyo:addcharmerrormsg', function (e, data) {
				categorizePDPClickEvent($.trim(data.errorMsg), 'Error Message');				
			});
			$(document).on('click', '.gtm-cyo-engrave-btn', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Engrave');
			});
			$(document).on('click', '.gtm-cyo-pickholder-btn', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Pick a Charm Holder');
			});
			$(document).on('click', '.gtm-cyo-addcharm-customize-btn', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Pick a Charm');
			});
			$(document).on('click', '.gtm-size-guide', function () {
				var guide = $.trim($(this).text());
				categorizePDPClickEvent($.trim($(this).closest('.product-detail').attr('data-product-name')), guide);
			});
			$(document).on('click touchend', '.s7thumboverlay', function () {
				if($(this).closest('.cyo-inline-pdp-section-image').length > 0){
					cyoPdpClickEvent($.trim($(this).closest('.product-detail').find('.cyo-inline-pdp-section-details').find('.product-name').text()), 'Alt Image');
				} else {
					pdpClickEvent($.trim($(this).closest('.product-detail').attr('data-product-name')), 'Next Alt Image');	
				}
			});
			$(document).on('s7image:swipe', function (e, data) {
				if($('.cyo-inline-pdp-section-image').length > 0){
					cyoPdpClickEvent($.trim($('.product-detail').find('.cyo-inline-pdp-section-details').find('.product-name').text()), 'Alt Image - Swipe '+data);
				} else {
					pdpClickEvent($.trim($('.product-detail').attr('data-product-name')), 'Next Alt Image - Swipe '+ data);	
				}
			});
			$(window).on('load', function () {
				setTimeout(function(){
					if ($('.product-detail').attr('data-gtm-data') !== undefined && $('.product-detail').attr('data-gtm-data') !== null) {
						let gtmData = JSON.parse($('.product-detail').attr('data-gtm-data'));
						var isProductSet = ($('.product-set-detail').length > 0) ? true : false;
						if(isProductSet){
							var shopTheLookID = $('.product-set-detail').data('pid');
							$.each(gtmData,function(key,element){
								element.shopTheLookID = shopTheLookID;
							});
						}
						var pageListEle = $('#navigatedPDPInfo');
						var pageListName = (pageListEle && pageListEle.attr('data-nav-pdpinfo')) ? $.trim(pageListEle.attr('data-nav-pdpinfo')) : '';
						if (gtmData && pageListName) {
							if(!isProductSet) {
								var productRating = $('.product-detail .yotpo-main-widget .avg-score') && $('.product-detail .yotpo-main-widget .avg-score').length > 0 ? parseFloat($.trim($('.product-detail .yotpo-main-widget .avg-score').text())) : '';
								if (productRating) {
									gtmData.productRating = parseFloat(productRating);
									if ($('.btn-secondary-cyo.btn-cyo-engrave').length > 0) {
										$('.btn-secondary-cyo.btn-cyo-engrave').attr('data-product-rating', gtmData.productRating);
									}
								}
							}else{
								$.each(gtmData, function(index, value) {
									var ratingsText = $('.set-item[data-pid='+value.id+']').find('.yotpo-stars .sr-only').text();
									if(ratingsText != ''){
										var ratingValue = parseFloat(ratingsText.split(' ')[0]);
										if(ratingValue > 0){
											value.productRating = ratingValue;
										}
									}
								});
							}
							dataLayer.push({
								event: 'productDetail',
								ecommerce: {
									detail: {
										actionField: {
											list: pageListName
										},
										products: (!isProductSet) ? [gtmData] : gtmData
									}
								}
							});
						}
					}
				},1000);
			});
			$(document).on('click', '.gtm-see-more', function () {
				if ($(this).parents('.cyo-plp-details').length) {
					cyoPlpEvent($.trim($(this).attr('data-seemore-name') + ' - ' + 'See More'), 'Swatch');
				} else {
					plpEvent($.trim($(this).attr('data-seemore-name') + ' - ' + 'See More'), 'Swatch');
				}
			});
			$(document).on('click', '.gtm-bannerImage-click', function () {
				plpEvent($.trim($(this).parents().find('.gtm-banner-label').text()), 'Banner');
			});
			$(document).on('click', '.gtm-bannerButton-click', function () {
				plpEvent($.trim($(this).parents().find('.gtm-banner-label').text()), 'Shop Now');
			});
			$(document).on('click', '.gtm-recently-viewed', function (e) {
				var pdpUrl = $('.page').attr('data-action');
				if (pdpUrl === 'Product-Show') {
					pdpClickEvent($.trim($(this).attr('data-recently-product')), $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
				}
				else if (pdpUrl === 'Cart-Show') {
					cartClickEvent($.trim($(this).attr('data-recently-product')), $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));	
				}
				else if($('.storepage').length > 0){
					homePageEvent($.trim($(this).attr('data-recently-product')), $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
				}
				else {
					plpEvent($.trim($(this).attr('data-recently-product')), $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
				}
			});
			$(document).on('click', '.cartRecommendationCarousel .slick-dots button', function (e) {
				var pdpUrl = $('.page').attr('data-action');
				if (pdpUrl === 'Product-Show') {
					pdpClickEvent('Next Products', $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
				}
				else if (pdpUrl === 'Cart-Show') {
					cartClickEvent('Next Products', $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));	
				}else if ($('.storepage').length > 0) {
					homePageEvent('Next Products', $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));	
				}
				else {	
					plpEvent('Next Products', $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
				}
			});
			$(document).on('click', '.gtm-product-plpclick', function () {
				if($(this).closest('.cyo-plp-section-view').length > 0) {
					if ($(this).closest('#flush-collapseTwo').length) {
						cyoPlpEvent($.trim($(this).attr('data-recently-product')), 'Select Charm Holder');
					} else {
						cyoPlpEvent($.trim($(this).attr('data-recently-product')), 'Select Charm');
						//cyoPageClickEvent('Modal Displayed', 'Charms Modal');
					}
				} else if ($(this).parents('.cyo-product-detail').length) {
					if ($(this).closest('#flush-collapseTwo').length) {
						cyoPlpEvent($.trim($(this).attr('data-recently-product')), 'Select Charm Holder');
					} else {
						cyoPlpEvent($.trim($(this).attr('data-recently-product')), 'Select Charm');
						//cyoPageClickEvent('Modal Displayed', 'Charms Modal');
					}
				} else {
					let pageUrl = $('.page').attr('data-action');
					if (pageUrl === 'Product-Show') {
						if ($('#itemAddedFlyout').length) {
							itemAddedCartClickEvent($.trim($(this).attr('data-recently-product')), 'Product Click');
						}else{
							pdpClickEvent($.trim($(this).attr('data-recently-product')), 'Product Click');
						}
					}
					else if (pageUrl === 'Cart-Show') {
						cartClickEvent($.trim($(this).attr('data-recently-product')), 'Product Click');	
					}
					else if ($('.storepage').length > 0) {
						homePageEvent($.trim($(this).attr('data-recently-product')), 'Product Click');
					}else {
						plpEvent($.trim($(this).attr('data-recently-product')), 'Product Click');
					}
				}
			});
			$(document).on('click', '.product-tile-container', function () {
				let eventLabel = $(this).find('.info-title') ? $(this).find('.info-title').text() : '';
				plpEvent(eventLabel, 'Product Click');
			});
			$(document).on('click', '.gtm-search-click', function () {
				searchClickEvent($.trim($(this).attr('data-search-name')), $(this).parents('.gtm-suggestion-heading').find('.gtm-search-find').attr('data-searchcategory-name'));
			});
			$(document).on('click', '.gtm-searchResult-click', function () {
				searchClickEvent($.trim($(this).text()), 'Suggested');
			});
			$(document).on('click', '.gtm-similar', function () {
				plpEvent($.trim($(this).attr('data-recently-product')), 'Similar Search Items');
			});
			$(document).on('click', '.gtm-similar-search', function (e) {
				plpEvent($.trim($(this).attr('data-recently-product')), $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
			});
			$('body').on('click', '.gtm-findstore-click', function () {	
				var pageUrl = $('.page').attr('data-action');
				if(pageUrl == 'Cart-Show'){					
					let data = {
						eventLabel : window.location.pathname,
						eventAction : 'Modal Displayed'
					};
					storeLocatorEvent(data);
				}					
			});
			$(document).on('gtm:storeModalDisplayed',function(){
				let data = {
					eventLabel : window.location.pathname,
					eventAction : 'Modal Displayed'
				};
				storeLocatorEvent(data);	
			});
			$('body').on('click', '.store-banner', function (e) {
				e.stopImmediatePropagation();
				let eventlabel = $.trim($(this).find('.banner-title').text());
				if (eventlabel) {
					dataLayer.push({
						event: 'GAevent',
						eventCategory: ($('.store-locator-container') && $('.store-locator-container').hasClass('storelocmodal')) ? 'Store Details Modal' : 'Store Details Page',
						eventAction: 'Content Slot Click',
						eventLabel: eventlabel
					});
				}
			});
			$('body').on('storeloc:distanceselect', function (e, data) {
				storeLocatorEvent(data);
			});
			$(document).on('gtm:storelocatorSearch',function(e, data){
				let zipcodeInp = data;
				if (zipcodeInp) {
					var gtmData = {};
					gtmData.eventAction = 'Search Performed';
					gtmData.eventLabel = zipcodeInp;
				}
				storeLocatorEvent(gtmData);
			});
			$('body').on('gtm:simpleSearch',function(e, data){
				let searchLabel = data;
				if (searchLabel) {
					dataLayer.push({
						event: 'GAevent',
						eventCategory: 'Search',
						eventAction: 'Search Performed',
						eventLabel: searchLabel
					});
				}
			});
			$('body').on('click','.store-directions-link,.store-detail-link,.storelocator-phone',function(){
				var storename = $(this).parents('.store-details').find('.store-name').data('store-fullname');
				if (storename) {
					var gtmData = {};

					if($(this).hasClass('store-directions-link')) {
						let btnname = $.trim($(this).parents('.form-check-label').find('.store-btn').text());
						let storetype = (btnname == 'Your Store') ? 'My store - ' : '';
						gtmData.eventAction = storetype + 'Get Directions';
						gtmData.CheckDetailModal = true;
					}else if($(this).hasClass('store-detail-link')) {
						gtmData.eventAction = 'Store Details';
					}else if($(this).hasClass('storelocator-phone')) {
						let btnname = $.trim($(this).parents('.form-check-label').find('.store-btn').text());
						let storetype = (btnname == 'Your Store') ? 'My store - ' : '';
						gtmData.eventAction = storetype + 'Call Store';
						gtmData.CheckDetailModal = true;
					}
					gtmData.eventLabel = $.trim(storename);
					storeLocatorEvent(gtmData);
				}
				
			});
			$('body').on('storeloc:storedetails', function (e, data) {
				if (data) {
					var gtmData = {};
					gtmData.eventAction = 'Store Details';
					gtmData.eventLabel = data;
					storeLocatorEvent(gtmData);
				}
			});
			$('body').on('storeloc:afterStoreDetailModalOpen', function (e, data) {
				if (data) {
					var gtmData = {};
					gtmData.eventAction = 'View Store Details';
					gtmData.eventLabel = data;
					storeLocatorEvent(gtmData);
				}
			});
			$('body').on('storeloc:mapmarker', function (e, data) {
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:nostoreerror', function (e, data) {
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:loadmore', function () {
				let data = {
					eventLabel : '',
					eventAction : 'Load More'
				};
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:saveasmystore', function (e, data) {
				data.CheckDetailModal = true;
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:zoom', function (e, data) {
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:usemylocation', function (e,data) {
				storeLocatorEvent(data);
			});
			$('body').on('storeloc:nozipcodeerr', function (e,data) {
				storeLocatorEvent(data);
			});
			$('body').on('click', '#only-instock', function () {
				let isShowOnlyStock = $(this).prop('checked');
				var checkboxStatus = isShowOnlyStock ? 'Yes' : 'No';
				let data = {
					eventLabel :'Show only in stock - '.concat(checkboxStatus.toUpperCase()),
					eventAction : 'Search Filter'
				};
				storeLocatorEvent(data);
			});
			$('body').on('click', '.gtm-store-modal-close', function () {
				var targetErrors = $('.store-locator .invalid-feedback');
				(targetErrors.length > 0) ? targetErrors.html('') : '';
				let data = {
					eventLabel : window.location.pathname,
					eventAction : 'Modal Closed',
					CheckDetailModal : true
				};
				storeLocatorEvent(data);
			});

			var storeLocatorInput = document.querySelector(
				'.store-locator .zipcode-input'
			);
			if(storeLocatorInput){
				storeLocatorInput.addEventListener('invalid', () => {
					let data = {
						eventLabel: $.trim($('#store-postal-code-error').text()),
						eventAction: 'Message Displayed',
					};
					storeLocatorEvent(data);
				});
			}
			
			$('body').on('swipe','.cartRecommendationCarousel', function(event, slick,direction){
				var pdpUrl = $('.page').attr('data-action');
				var swipeData = $.trim($(this).closest('.recommendations').find('.gtm-text').text());
				if (pdpUrl === 'Product-Show') {
					pdpClickEvent('Carousel-Swipe '+ direction, swipeData);
				}else if (pdpUrl === 'Cart-Show') {
					cartClickEvent('Carousel-Swipe '+ direction, swipeData);	
				}else if ($('.storepage').length > 0) {
					homePageEvent('Carousel-Swipe '+ direction, swipeData);	
				}
				else {	
					plpEvent('Carousel-Swipe '+ direction, swipeData);
				}
			});
			
			$('body').on('swipe','.flyout-carousel', function(event, slick,direction){
				var pdpUrl = $('.page').attr('data-action');
				var swipeData = $(this).closest('.recommendations').find('.gtm-text').text();
				if (pdpUrl === 'Product-Show') {
					if ($('#itemAddedFlyout').length) {
						itemAddedCartClickEvent('Carousel-Swipe '+ direction, swipeData);
					}
				}
			});

			$(document).on('click', '.gtm-increaseButton-click', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-increment-name')), 'Increase Quantity');
			});
			$(document).on('click', '.gtm-decreaseButton-click', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Decrease Quantity');
			});
			$(document).on('click', '.gtm-pdpswatch-click', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-pdp-swatch')), 'Swatch');
			});
			$(document).on('click', '.gtm-product-size-click', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-pdpProduct-name')), 'Select Product Size');
			});
			$(document).on('pdp:wishlistItem', function (e, data) {
				if(data){
					categorizePDPClickEvent(data, 'Add to Wishlist');
				}
			});
			$(document).on('click', '.gtm-findstore-click', function () {
				categorizePDPClickEvent($.trim($(this).attr('data-findproduct-name')), 'Find Store');
			});
			$(document).on('click', '.gtm-pdpProductdetails-click', function () {	
				if($(this).attr('aria-expanded') == 'false'){
					categorizePDPClickEvent($.trim($(this).attr('data-pdpproductdetails-name')), 'Close Product Details');
				} else {
					categorizePDPClickEvent($.trim($(this).attr('data-pdpproductdetails-name')), 'Open Product Details');
				}
			});
			$(document).on('click', '.gtm-helpandreturns-click', function () {
				if($(this).attr('aria-expanded') == 'false'){
					categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Close Helpful Information - ' + $.trim($(this).text()));	
				}else{
					categorizePDPClickEvent($.trim($(this).attr('data-product-name')), 'Open Helpful Information - ' + $.trim($(this).text()));
				}
			});
			$(document).on('click', '.gtm-add-to-cart', function () {
				if ($(this).parents('.cyo-page').length > 0) {
					var cartItems = $(this).data('gtm-array');
					var productList = [];
					if(cartItems){
						$.each(cartItems,function(indx,item){
							productList.push(item.name);
						});
					}
					var products = productList.length > 0 ?  productList.join(' - ') : $.trim($(this).attr('data-pdpaddtocart-name')); 
					cyoPlpEvent(products, 'Add to Cart');
				}else{
					pdpClickEvent($.trim($(this).attr('data-pdpaddtocart-name')), 'Add to Cart');
				}
			});

			$(document).on('pdp:productKit', function (e, data) {
				var isProductSet = ($('.product-set-detail').length > 0) ? true : false;
				let gtmData = data;
				if (gtmData) {
					dataLayer.push({
						cartAdditionSource : isProductSet ? 'Shop the Look' : 'Product Detail Page',
						event: 'addToCart',
						ecommerce: {
							add: { 
								products: gtmData.addAllitemtoCart ? gtmData.productItem[0] : [gtmData.productItem]
							}
						}
					});
				}
			});

			$('body').on('charmPromo:progress', function (e, data) {
				setTimeout(function(){
					if(data && $('.prorated-msg-wrapper').length){
						var promoMsg = $('.prorated-msg-wrapper:visible').length ? $('.prorated-msg-wrapper:visible').text().trim() : '';
						charmPromoMessageEvent(promoMsg);				
						charmPromoProgressEvent(data);
					}
				},500);
			});

			$(document).on('click','.editorialComponent-click',function(){
				let eventLabel = $.trim($(this).data('gtm-label'));
				homePageEvent(eventLabel, 'Textbox Component');
			});

			$(document).on('click','.popular-cat-link',function(){
				let eventLabel = $.trim($(this).data('gtm-label'));
				homePageEvent(eventLabel, 'Popular Category Banner');
			});

			$(document).on('click', '.mainBannerLink', function () {
				let eventLabel = $.trim($(this).data('gtm-label'));
				homePageEvent(eventLabel, 'Main Banner');
			});

			$(document).on('click', '.promotionalBannerLink', function () {
				let eventLabel = $.trim($(this).data('gtm-label'));
				homePageEvent(eventLabel, 'Promotion content Tile/Banner');
			});

			$(document).on('click', '.imgandtextLink', function () {
				let eventLabel = $.trim($(this).data('gtm-label'));
				homePageEvent(eventLabel, 'ImageandText');
			});

			$(document).on('click', '.heroNacross-btnlink', function () {
				let eventLabel = $.trim($(this).data('gtm-buttonlabel'));
				homePageEvent(eventLabel, 'HeroNAcross');
			});
			//HeroNAcross
			$(document).on('click', '.hero-n-across', function () {
				let eventaction = '';
				if ($(this).attr('data-cross-count') == '2') {
					eventaction = 'Two Across';
				} else if ($(this).attr('data-cross-count') == '3') {
					eventaction = 'Three Across';
				} else if ($(this).attr('data-cross-count') == '4') {
					eventaction = 'Four Across';
				} else if ($(this).attr('data-cross-count') == '5') {
					eventaction = 'Five Across';
				} else {
					eventaction = 'Six Across';
				}

				homePageEvent($.trim($(this).attr('data-nacross-gaeventname')), eventaction);
			});
			//TextBoxComponent
			$(document).on('click', '.richtxtComponent', function () {
				var gtmLabel = $.trim($(this).attr('data-gtm-label'));
				homePageEvent(gtmLabel, 'Textbox Component');
			});
			//Tiled-Block
			$(document).on('click', '.tile-image,.tiled-block,.tiled-block-image', function () {
				if($(this).parent('.product-click-track').length == 0) {
					var gtmLabel = $.trim($(this).attr('data-gtm-label'));
					var eventLabel = '';
					if(!$(this).hasClass('tiled-block')){
						eventLabel = gtmLabel;
					}else{
						eventLabel = gtmLabel;
					}
					homePageEvent(eventLabel,'Tiled Block');
				}
			});
			//HeroComponent
			$(document).on('click', '.herocomponent', function () {
				var bannerHeading = $.trim($(this).attr('data-gtm-heading'));
				homePageEvent(bannerHeading, 'Hero');
			});
			//BannerComponent
			$(document).on('click', '.bannercomponent', function () {
				let bannerHeading = $.trim($(this).attr('data-gtm-heading'));
				homePageEvent(bannerHeading, 'Banner');
			});
			//BannerComponent
			$(document).on('click', '.mainBannerLink,.productListLink', function () {
				let bannerHeading = $.trim($(this).attr('data-gtm-heading'));
				let eventLabel = '';
				if($(this).hasClass('mainBannerLink')){
					eventLabel = 'Main Banner';
				}
				if($(this).hasClass('productListLink')){
					eventLabel = 'Product List Tile';
				}
				homePageEvent(bannerHeading, eventLabel);
			});

			$(document).on('click', '.gtm-footer-toggle', function () {
				var ariaExpended = $.trim($(this).attr('aria-expanded'));
				var eventLabel = ariaExpended === 'false' ? 'Close Details' : 'Open Details';
				footerNavigationEvent(eventLabel, $.trim($(this).text()));
			});
			$(document).on('click', '.gtm-store-addresses-edit', function () {
				checkoutClickEvent('Edit Addresses', 'Addresses');
			});
			$(document).on('click', '.gtm-edit-addresses', function () {
				checkoutClickEvent('Edit Address', 'Addresses');
			});
			$(document).on('click', '.gtm-add-new-addresses', function () {
				checkoutClickEvent('Add a New Address', 'Addresses');
			});
			$(document).on('click', '.gtm-become-privacy-notice', function () {
				checkoutClickEvent('Privacy Notice', 'Confirmation Page');
			});
			$(document).on('click', '.gtm-same-as-shipping', function () {
				checkoutClickEvent('Billing Same As Shipping', 'Payment Details');
			});
			$(document).on('click', '.gtm-join-our-email', function () {
				checkoutClickEvent('Email Opt In', 'Addresses');
			});
			$(document).on('click', '.gtm-promo-code-error', function () {
				checkoutClickEvent('', 'Payment Details Page');
			});
			$(document).on('click', '.gtm-store-see-details', function () {
				checkoutClickEvent('Pick up In-Store' + '-' + $.trim($(this).text()), 'Addresses');
			});
			$(document).on('click', '.gtm-store-switch-shipping', function () {
				checkoutClickEvent('Pick up In-Store - Switch to Shipping', 'Addresses');
			});
			$(document).on('click', '.gtm-shipping-privacy-notice', function () {
				checkoutClickEvent('Privacy Notice', 'Addresses');
			});

			$(document).on('click', '.gtm-checkout-btn', function () {
				miniCartClickEvent('Proceed to Checkout', 'Multiple Products');
			});
			// $(document).on('click', '.gtm-remove-button', function () {
			// 	ecommerceClickEvent($.trim($(this).attr('gtm-data-product-name')), 'Remove from Cart'); //for page 23 - line 766 already there
			// });
			$(document).on('click', '.gtm-piece-to-match', function () {
				var eventAction = $.trim($(this).parents('.recommendations').find('.text-center').text());
				if ($('#itemAddedFlyout').length) {
					itemAddedCartClickEvent($.trim($(this).attr('gtm-data-product')), eventAction);
				}
			});
			$(document).on('click', '.gtm-continue-shopping', function (e) {
				e.preventDefault();
				$('#itemAddedFlyout').modal('hide');
				itemAddedCartClickEvent($.trim($(this).attr('data-product-itemname')), $.trim($(this).text()));
			});
			$(document).on('click', '.gtm-item-checkout', function () {
				itemAddedCartClickEvent($.trim($(this).attr('data-product-itemname')), 'Proceed to Checkout');
			});	
			$(document).on('click', '.gtm-slick-dots .slick-dots button', function (e) {
				if ($('.page').data('action') === 'Product-Show') {
					if ($('#itemAddedFlyout').length) {
						itemAddedCartClickEvent('Next Products', $.trim($(e.currentTarget).closest('.recommendations').find('.gtm-text').text()));
					}
				}
			});
			$(document).on('cart:removeitem', function (e, data) {
				var eventLabel = data.name;
				ecommerceClickEvent(eventLabel, 'Remove from Cart');
			});
			$('body').on('click', '.gtm-cancel-button', function () {
				ecommerceClickEvent('Cancel', 'Remove from Cart');
			});
			$(document).on('cart:update', function (e, data) {
				if (data.message === 'Item successfully removed') {
					ecommerceClickEvent('Success', 'Remove from Cart');
				}
			});
			$('body').on('click', '.gtm-ymal-add-to-cart', function () {
				var eventLabel = $.trim($(this).attr('gtm-data-product'));
				var title = $.trim($(this).parents('.addOnRecommendation').find('.label_addOn').text());
				if(eventLabel){
					cartClickEvent(eventLabel, title + ' - Add to Cart');
				}
			});
			$(document).on('cart:shipmentUpadte', function (e, data) {
				if (data === 'Shipping') {
					cartClickEvent(data, 'Select Delivery Method');
				} else {
					cartClickEvent('Pick Up', 'Select Delivery Method');
				}
			});
			$('body').on('click','.gtm-addOn-analytics',function(){
				var eventLabel = $.trim($(this).attr('gtm-data-product'));
				var title = $.trim($(this).parents('.addOnRecommendation').find('.label_addOn').text());
				if(eventLabel){
					cartClickEvent(eventLabel,title);
				}
			});

			$('body').on('click', '.gtm-select-a-store', function () {
				var eventLabel = $.trim($(this).text());
				if (eventLabel === 'Find Store') {
					cartClickEvent('Delivery Method', 'Find Store');
				} else {
					cartClickEvent('Delivery Method', 'Change Store');
				}
			});

			$('.gtm-info-icon').hover(function () {
				cartClickEvent('Shipping Info Icon', 'Delivery Method');
			});
			$('body').on('click', '.gtm-phone-number', function () {
				cartClickEvent('Need Help Finding Something? - Call - Click', 'Other Actions');
			});
			$('body').on('click', '.gtmShopNow', function () {
				cartClickEvent($.trim($(this).text() + '-' + 'Click'), 'Banner');
			});
			$(document).on('cart:movetowishlist', function (e, data) {
				cartClickAnalyticsEvent(data, 'Add to Wishlist');
			});
			$(document).on('cart:update', function (e, data) {
				if (data.msg === 'Item successfully moved from cart to wishlist' && !data.cyoSet) {
					cartClickEvent('Success', 'Move to Wish List');
				}
			});
			if ($('.page').data('action') === 'Cart-Show') {
				$('body').on('click', '.gtm-item-swatch-click', function () {
					cartClickEvent($.trim($(this).attr('data-display-name')), 'Swatch');
				});
			}
			$(document).on('cart:removeitem', function (e, data) {
				if (data) {
					dataLayer.push({
						event: 'removeFromCart',
						cartRemovalSource: (data.removalSource) ? data.removalSource : '',
						ecommerce: {
							remove: {
								products: [data.gtmProductData]
							}
						}
					});
				}
			});
			$(document).on('wishlist:removeFromWishlist', function (e, data) {
				if (data) {
					var gtmDetails = data.gtmData;
					dataLayer.push({
						event: 'removeFromWishlist',
						ecommerce: {
							remove: {
								products: gtmDetails
							}
						}
					});
				}
			});
			$(document).on('gtmcart:quantityupdate', function (e, data) {
				if (data) {
					dataLayer.push({
						cartAdditionSource : 'Cart Page',
						event: 'addToCart',
						ecommerce: {
							add: {
								products: [data]
							}
						}
					});
				}
			});
			$(document).on('cart:quantityupdate', function (e, data) {
				var eventLabel = data.quantity;
				var eventAction = data.name;
				ecommerceClickEvent('Quantity Change to ' + eventLabel, eventAction);
			});
			$(document).on('cart:ymlupdate', function (e, data) {
				if (data) {
					dataLayer.push({
						event: 'addToCart',
						ecommerce: {
							add: {
								products: [data]
							}
						}
					});
				}
			});
			$(document).on('cart:upsellupdate', function (e, data) {
				if (data) {
					data.quantity = 1;
					dataLayer.push({
						event: 'addToCart',
						cartAdditionSource: 'Cart Page - Customers Also Bought',
						ecommerce: {
							add: {
								products: [data]
							}
						}
					});
				}
			});

			$(document).on('click','.product-click-track-upsell', function () {
				var item = JSON.parse($(this).parents('.product').attr('data-upsell-gtm'));
				var itemIndex = $(this).parents('.slick-slide').attr('data-slick-index');
				if(item){
					item.position = parseInt(itemIndex) + 1;
					let productId = item.id;
					if(productId && productId.indexOf('STL') > -1) {
						item.shopTheLookID = productId;
					}
					dataLayer.push({
						event: 'productClick',
						ecommerce: {
							click: {
								actionField: {
									list: 'Customers Also Bought'
								},
								products: [item]
							}
						}
					});	
					
				}
				
			});

			$('body').on('click', '.gtm-checkout-btn', function () {
				var result = $(this).attr('data-out-of-stock');
				var eventLabel = $(this).attr('data-out-of-stock-msg');
				if (result === 'true') {
					cartClickEvent(eventLabel, 'Message Displayed');
				}
			});

			if ($('.page').data('action') === 'Cart-Show') {
				if ($('.page').find('.cart-page').hasClass('d-none') === true) {
					var eventLabel = $.trim($('.page').find('.cart-empty .cart-empty-text').text());
					cartClickEvent(eventLabel, 'Message Displayed');
				}
				else {
					$('.page').find('.cart-page .product-info').each(function (index, element) {
						var inventoryMessage = $(element).find('.line-item-availability .line-item-attributes').text();
						if (inventoryMessage === 'Out of stock online') {
							$('.page').find('.cart-page .product-info-section .item-attributes .line-item-header .gtm-product').each(function (index, element) {
								var productName = $.trim($(element).text());
								cartClickEvent(productName + '-' + inventoryMessage, 'Message Displayed');
							});
						}
						return false;
					});
				}
			}

			if ($('.page').data('action') === 'Cart-Show') {
				if ($('.page').find('.cart-page').hasClass('d-none') === false) {
					$('.page').find('.cart-page .product-info').each(function (index, element) {
						var inventoryCheckMessage = $(element).find('.line-item-availability .line-item-attributes').hasClass('urgent');
						var inventoryMessage = $(element).find('.line-item-availability .line-item-attributes').text();
						if (inventoryCheckMessage) {
							$('.page').find('.cart-page .product-info-section .item-attributes .line-item-header .gtm-product').each(function (index, element) {
								var productName = $.trim($(element).text());
								cartClickEvent(productName + '-' + inventoryMessage, 'Message Displayed');
							});
							return false;
						}
					});

				}
			}

			// Checkout 
			$(document).on('click', '.forgot-password', function() {
				checkoutClickEvent('Forgot Password', 'Login Page');
			});
			$(document).on('click', '.checkout-as-guest', function() {
				checkoutClickEvent('Continue as Guest', 'Login Page');
			});
			$(document).on('click', '.gtm-signin', function () {
				if($(this).parents('.checkoutLoginWrapper') && $(this).parents('.checkoutLoginWrapper').length > 0){
					checkoutClickEvent('Sign In', 'Login Page');
				}
			});
			$(document).on('click', '.btn-logout', function() {
				accountAnalyticsEvent('Logout','');
			});
			$(document).on('user:login', function () {
				accountAnalyticsEvent('Login','');
			});
			$(document).on('click', '.gtm-return-to-cart', function() {
				checkoutClickEvent('Return To Cart', 'Delivery Method Page');
			});
			$(document).on('click', '.gtm-shipping-method', function() {
				checkoutClickEvent($.trim($(this).text()), 'Delivery Method Page');
			});
			$(document).on('click', '.gta-gift-message', function() {
				checkoutClickEvent('‘Include an Optional Gift Message', 'Delivery Method Page');
			});
			$(document).on('click', '.gtm-cancel-ups-modal', function() {
				checkoutClickEvent('Cancel', 'Address Suggestions Page');
			});
			$(document).on('click', '.gtm-close-modal', function() {
				checkoutClickEvent('Exit', 'Address Suggestions Page');
			});
			$(document).on('click', '.gtm-editdelivery-address', function() {
				checkoutClickEvent('Edit Addresses', 'Payment Details Page');
			});
			$('a.link.gtm-gift-card-header').on('click', function() {
				checkoutClickEvent('Redeem a Gift Card', 'Payment Details Page');
			});
			$(document).on('click', '.gtm-redeem-close', function() {
				checkoutClickEvent('Close Gift Card Panel', 'Payment Details Page');
			});
			$('a.gtm-gift-card-link-balance').on('click', function() {
				checkoutClickEvent('Check Gift Card Balance', 'Payment Details Page');
			});
			
			$(document).on('click', 'gtm-add-to-email-list', function() {
				checkoutClickEvent('Email Opt In', 'Addresses');
			});

			$('a.privacy-notice').on('click', function() {
				checkoutClickEvent('Privacy Notice', 'Addresses');
			});
			
			
			$(document).on('gtm:promocodeAppliedError', function (e, data) {
				checkoutClickEvent(data.errorMessage, 'Payment Details Page');
			});
			$(document).on('gtm:promocodeAppliedSuccess', function () {
				checkoutClickEvent('Apply Promo Code', 'Payment Details Page');
			});
			$(document).on('gtm:seeDetails', function (e, data) {
				checkoutClickEvent('Pick up In-Store'+'-'+data, 'Addresses');
			});

			$(document).on('gtm:hideDetails', function (e, data) {
				checkoutClickEvent('Pick up In-Store'+'-'+data, 'Addresses');
			});

			$(document).on('gtm:checkoutLogin', function (e, data) {
				if (data) {
					var ecom = {
						checkout: {
							actionField: {'step': 0, 'option': 'Login'},
							products: JSON.parse(data)
						}
					};
					var pageString = '/L0_Home/L1_Checkout(0)';
				}
				checkoutGlobalPageDetalsEvent(pageString);
				checkoutImpressionClickEvent(ecom);
			});

			$(document).on('gtm:checkoutAddress', function (e, data) {
				if (data) {
					var ecom = {
						checkout: {
							deliveryMethod: getSelectedShippingMethod(),
							actionField: {'step': 1, 'option': 'Addresses & Delivery Method'},
							products: JSON.parse(data)
						}

					};
					var pageString = '/L0_Home/L1_Checkout(1)';
				}
				checkoutGlobalPageDetalsEvent(pageString);
				checkoutImpressionClickEvent(ecom);
			});

			$(document).on('gtm:giftMessageIncluded', function () {
				var giftMsg = $.trim($('.gift-message-text').val());
				var eventLbl = giftMsg ? 'Yes' : 'No';
				checkoutClickEvent(eventLbl,'Gift Message Included');	
			});

			$(document).on('gtm:paymentSection', function (e, data) {
				if (data) {
					var ecom = {
						checkout: {
							deliveryMethod: getSelectedShippingMethod(),
							actionField: {'step': 2, 'option': 'Payment Details'},		
							products: JSON.parse(data)
						}
					};
					var pageString = '/L0_Home/L1_Checkout(2)';
				}
				checkoutGlobalPageDetalsEvent(pageString);
				checkoutImpressionClickEvent(ecom);
			});

			$(document).on('gtm:orderPlaced', function (e, data) {
				if (data) {
					var ecom = {
						checkout: {
							deliveryMethod: getSelectedShippingMethod(),
							actionField: {'step': 3, 'option': 'Order Review'},
							products: JSON.parse(data)
						}
					};
					var pageString = '/L0_Home/L1_Checkout(3)';
				}
				checkoutGlobalPageDetalsEvent(pageString);
				checkoutImpressionClickEvent(ecom);
				checkoutSMSSignupEvents();
			});
			
			$(document).on('click', '.gtm-edit-address', function () {
				checkoutClickEvent('Edit Addresses', 'Payment Details Page');
			});
			
			$(document).on('click', '.gtm-gift', function () {
				checkoutClickEvent('Delivery Method Page', 'Payment Details Page');
			});
			// $(document).on('click', '.gtm-suggested-cancel', function () {
			// 	checkoutClickEvent('Cancel', 'Address Suggestions Page');
			// });
			// $(document).on('click', '.gtm-suggested-close', function () {
			// 	checkoutClickEvent('Exit', 'Address Suggestions Page');
			// }); //Dublicate event - line: 958
			$(document).on('continiueBtnClick:success', function () {
				if ($('input[id=suggested-address]:checked').val() == 'on') {
					checkoutClickEvent('Select Suggested', 'Address Suggestions Page');
				} else {
					checkoutClickEvent('Address as Entered', 'Address Suggestions Page');
				}
			});
			$(document).on('gtm:promocodeAppliedError', function (e,data) {
				checkoutClickEvent(data.errorMessage, 'Payment Details Page');
			});
			
			if($('.page').data('action') == 'Cart-Show') {
				if($('.prorated-msg-wrapper').length > 0) {
					var progressValue = $('.prorated-msg-wrapper:visible').attr('data-progress').trim();
					$('body').trigger('charmPromo:progress',progressValue);
				}
			}

			if ($('.page').data('action') === 'Order-Confirm' || $('.page').data('action') === 'COPlaceOrder-Submit' ) {
				var $orderSummary = $('.page').find('.order-Summary-changes');
				if ($orderSummary.attr('data-gtm-payment') && $orderSummary.attr('data-gtm-product')) {
					var gtmPaymentData = JSON.parse($orderSummary.attr('data-gtm-payment'));
					var gtmProductData = JSON.parse($orderSummary.attr('data-gtm-product'));
					var gtmDeliveryMethod = $orderSummary.attr('data-gtm-deliverymethod');
					var orderPaymentMethod = $orderSummary.attr('data-order-paymentmtd');
					var isGiftFlag = $orderSummary.data('gtm-isgift');
					var smsMarketingOptin = $orderSummary.data('smsmarketingoptin');
					if (gtmPaymentData && gtmProductData) {
						var ecom = {
							purchase: {
								actionField: gtmPaymentData,
								products: gtmProductData
							}
						};
						
						dataLayer.push({
							event: 'purchase',
							giftMessageIncluded:isGiftFlag ? 'Yes' : 'No',
							paymentMethod:orderPaymentMethod,
							deliveryMethod:gtmDeliveryMethod,
							ecommerce: ecom
						});
					}
					if(smsMarketingOptin){
						dataLayer.push({
							event: 'GAevent',
							eventCategory: 'Checkout Funnel',
							eventAction: 'Order Confirmation',
							eventLabel: 'SMS Marketing Signup'
						});
					}
				}
				let pageString = '/L0_Home/L1_Confirmation';
				checkoutGlobalPageDetalsEvent(pageString);
			}
			$(document).on('change', '.shipping-method-block input.form-check-input', function() {
				checkoutClickEvent('Shipping', 'Delivery Method');
			});
			$(document).on('click', '.gtm-cyo-exp-entry', function () {
				cyoPlpEvent($.trim($(this).text()), 'Start Customizing Modal');
			});
			$(document).on('gtm:emailCapture', function (e,data) {
				emailCaptureEvent(data.email, data.userHashedEmail);
			});

			$(document).on('gtm:customModalHomepage', function (e,data) {
				if(data.eventlabel != ''){
					homePageEvent(data.eventlabel, data.eventaction);
				}	
			});

			//Curalate Click
			window.addEventListener('click', function() {
				var containerID = $('.curalatspace').attr('data-crl8-container-id');
				var curalatePDPs = '#crl8-'+containerID+'-multisize-grid-modal a';
				if($(curalatePDPs).length > 0){
					$(curalatePDPs).on('click', function(e){
						e.stopImmediatePropagation();
						e.preventDefault();
						var curalateURL = $(this).attr('href');
						curalateURL = utils.appendParamToURL(curalateURL, 'nav','others');
						window.open(curalateURL, '_blank');
					});
				}					
			});

			$('.curalatspace').on('click', function () {
				var containerID = $('.curalatspace').attr('data-crl8-container-id');
				if (containerID == 'homepage') {
					var bannerHeading = $.trim($(this).attr('data-gtm-heading'));
					homePageEvent(bannerHeading, 'Curalate');
				}
			});
			//Link Banner Component
			$(document).on('click','.shop-category-label-a',function(){
				var gtmCategoryLabel = $.trim($(this).text());
				homePageEvent(gtmCategoryLabel, 'Link Banner');
			});
			//ImageTextComponent
			$(document).on('click','.image-component',function(){
				var gtmLabel = $.trim($(this).attr('data-gtm-label'));
				homePageEvent(gtmLabel, 'Image and Text');
			}); 
			//Content Asset
			$(document).on('click','.contentAssetComponent',function(){
				var gtmLabel = $.trim($(this).attr('data-gtm-label'));
				homePageEvent(gtmLabel, 'Content Asset');
			});

			//Custom Content Asset
			$(document).on('click','.customContentAsset',function(){
				var gtmLabel = $.trim($(this).attr('data-gtm-label'));
				homePageEvent(gtmLabel, 'Content Asset');
			});

			//Artisan Click - Our story
			$(document).on('click','.artisan-slider',function(e){
				var targetAction = '';
				var target = $(e.target);
				if(target.hasClass('name')){
					targetAction = 'Slide Name Click';
				}else if(target.hasClass('tile-image')){
					targetAction = 'Slide Image Click';
				}else{
					targetAction = 'Slide Plus Icon Click';
				}
				var targetOwner = target.data('user');
				if(targetOwner){
					var targetName = $('.artisan-slider .slick-slide').not('.slick-cloned').find('.name[data-user='+targetOwner+']').text();
					ourStoryEvent('Meet the Artisan - ' + targetName,targetAction);
					ourStoryEvent('Meet the Artisan - '+ targetName,'Popup Displayed');
				}
				
			});

			$(document).on('click','.meetArtisansModal .modal-close-icon',function(){
				var visibleItem = $('.artisan-info:not([style*="display: none"])').attr('id');
				if(visibleItem){
					var targetName = $('.artisan-slider .slick-slide').not('.slick-cloned').find('.name[data-user='+visibleItem+']').text();
					ourStoryEvent('Meet the Artisan - '+targetName,'Popup closed');
				}
			});

			$(document).on('click','.as-slider,.artisan-progressBar span',function(e){
				var target = $(e.target);
				var targetCategory = '';
				if(target.hasClass('progressBar')){
					targetCategory = 'Progressbar Click';
				}else if(target.hasClass('slick-next-btn')) {
					targetCategory = 'Next Click';
				}else if(target.hasClass('slick-prev-btn')) {
					targetCategory = 'Previous Click';
				}
				var artisanName = $('.artisan-slider .slick-slide.slick-current').find('.name').text();
				if(artisanName && targetCategory){
					ourStoryEvent('Meet the Artisans Slider',targetCategory);
				}
			});

			$('.activity-slider').on('swipe', function(event, slick, direction){
				var slideName = '';
				var silderGroup = '';
				if(slick.$slider.hasClass('artisan-slider')){
					slideName = 'Meet the Artisans Slider';
					silderGroup = 'Swipe ' + direction;
				}else{
					slideName = 'Making the Jewelry Slider';
					silderGroup = 'Swipe ' + direction;
				}
				if(slideName){
					ourStoryEvent(slideName,silderGroup);
				}
			});

			$(document).on('click','.care-beyond-slider-wrapper .slick-dots li button', function() {
				var targetSlideName = $('.care-beyond-slider-wrapper .slick-slide.slick-current .beyond-description').find('h3.slide-title').text();
				if(targetSlideName){
					ourStoryEvent('Care Beyond the Craft','Slide dot click');			
				}
			});

			$('.care-beyond-slider-wrapper').on('swipe', function(event, slick, direction) {
				ourStoryEvent('Care Beyond the Craft','Swipe ' + direction);
			});

			$(document).on('click','.cta-learnmore',function(){
				var targetSlideName = $(this).parent('.beyond-description').find('.slide-title').text();
				if(targetSlideName){
					ourStoryEvent('Care Beyond the Craft - ' + targetSlideName,'Learn more click');
				}
			});

			$(document).on('click','.artisan-work-slider',function(e){
				var targetAction = '';
				var target = $(e.target);
				var targetStep = target.data('target');
				if(target.hasClass('name')){
					targetAction = 'Slide Title Click';
				}else if(target.hasClass('img-fluid')){
					targetAction = 'Slide Image Click';
				}else{
					targetAction = 'Slide Plus Icon Click';
					var iconName = target.parent('.know-more').data('target');
				}
				targetStep = targetStep ? targetStep : iconName;
				if(targetStep){
					var targetName = $('.artisan-work-slider .slick-slide').not('.slick-cloned').find('.name[data-target='+targetStep+']').text();
					ourStoryEvent('Making the Jewelry Slider - ' + targetName,targetAction);
				}
				
			});

			$(document).on('makingvideo:slideactive',function(e,data){
				if(data){
					ourStoryEvent('Making the Jewelry - ' + data,'Video Popup Displayed');
				}
			});
			$('.activity-video-slider').on('swipe', function(event, slick, direction){
				let targetTitle =  $('.activity-video-slider .slick-slide.slick-current .embed-video-info .title').text();				
				if(targetTitle){
					ourStoryEvent('Making the Jewelry Video Slider','Swipe ' + direction);
					ourStoryEvent('Making the Jewelry - ' + targetTitle,'Video Popup Displayed');
				}
			});

			$(document).on('click','.makingJewelleryModal .modal-close-icon',function(){
				var visibleItem = $(this).parent('.embedded-videos').data('action').toUpperCase();
				if(visibleItem){
					ourStoryEvent('Making the Jewelry - ' + visibleItem,'Video Popup Closed');
				}
			});

			$(document).on('click','.mk-slider,.mkjewel-progressBar span',function(e){
				var target = $(e.target);
				var targetCategory = '';
				if(target.hasClass('progressBar')){
					targetCategory = 'Progressbar Click';
				}else if(target.hasClass('slick-next-btn')) {
					targetCategory = 'Next Click';
				}else if(target.hasClass('slick-prev-btn')) {
					targetCategory = 'Previous Click';
				}
				var targetName = target.hasClass('video-gallery') ? 'Making the Jewelry Video Slider' : 'Making the Jewelry Slider'; 
				if(targetName && targetCategory){
					ourStoryEvent(targetName,targetCategory);
				}
				if(target.hasClass('video-gallery')){
					var targetTitle =  $('.activity-video-slider .slick-slide.slick-current .embed-video-info .title').text();
					ourStoryEvent('Making the Jewelry - ' + targetTitle,'Video Popup Displayed');
				}
			});

			$(document).on('click','.continue-the-story-btn',function(){
				ourStoryEvent('Timeline', $.trim($(this).text()+' Click'));
			});

			$(document).on('click','.back-to-starting-button',function(){
				ourStoryEvent('Timeline', $.trim($(this).text()+' Click'));
			});

			$(document).on('gtm:timelineDrag', function (e,perc) {
				var draggedString = 'Timeline Dragged to ' + parseInt(perc) + '%';
				ourStoryEvent('Timeline', draggedString);
			});

			$(document).on('gtm:progressBarClick', function (e,perc) {
				var draggedString = 'Progress Bar Movement to ' + parseInt(perc) + '%';
				ourStoryEvent('Timeline', draggedString);
			});

			$(document).on('click','.cta-maplearnmore',function(){
				var btnLabel = $.trim($(this).text());
				ourStoryEvent('Greetings From Texas', btnLabel+' Click');
				ourStoryEvent('Greetings From Texas', 'Location Modal Displayed');
			});

			$(document).on('click','.cta-backtomap',function(){
				var btnLabel = $.trim($(this).text());
				ourStoryEvent('Greetings From Texas', btnLabel+' Click');
			});

			$(document).on('gtm:texasMapNavigation', function (e,data) {
				var evtLabel = 'Texas Map' + ' ' + $.trim(data.title);
				ourStoryEvent(evtLabel,$.trim(data.action));
			});

			$(document).on('gtm:texasMapNavigationBefore', function (e,location) {
				var evtLabel = 'Texas Map' + ' ' + $.trim(location);
				ourStoryEvent(evtLabel, 'Location Modal Displayed');
			});

			$('body').on('swipe','.locations-slider-wrapper', function(event, slick,direction){
				var swipeData = 'Location Modal Swipe ' + direction;
				ourStoryEvent('Texas Map', swipeData);
			});

			$(document).on('click','.locations-slider-wrapper .slick-arrow',function(){
				ourStoryEvent('Texas Map', $.trim($(this).text()) +' Click');
			});

			$(document).on('gtm:LocationModalClose',function(e,data){
				ourStoryEvent(data.title, data.action);
			});

			$(document).on('click','.gtm-expandable-dates-header,.expandable-dates .up',function(){
				let eventAction = $(this).attr('aria-expanded') == 'false' ? 'Collapse Location Details' : 'Expand Location Details';
				let eventLabel = $(this).hasClass('up') ? $.trim($(this).parents('.expandable-dates').find('.gtm-location').text()) : $.trim($(this).find('.gtm-location').text());
				trunkEvent(eventLabel, eventAction);
			});

			$(document).on('click','.gtm-store-location',function(){
				let eventAction = $.trim($(this).text());
				let eventLabel = $.trim($(this).parents('.expandable-dates').find('.gtm-location').text());
				trunkEvent(eventLabel, eventAction);
			});

			$(document).on('click','.gtm-customer-service-number',function(){
				let eventAction = 'Telephone Call';
				let eventLabel = 'Customer Service';
				trunkEvent(eventLabel, eventAction);
			});

			$(document).on('click','#trunk-faq .gtm-question',function(){
				let eventAction = $(this).attr('aria-expanded') == 'false' ? 'Collapse FAQs' : 'Expand FAQs';
				let eventLabel = $.trim($(this).children('p').text());
				trunkEvent(eventLabel, eventAction);
			});

			$(document).on('click','#trunk-show-caraousel .slick-prev',function(){
				trunkEvent('Featured Designs','Previous Click');
			});
 
			$(document).on('click','#trunk-show-caraousel .slick-next',function(){
				trunkEvent('Featured Designs','Next Click');
			});

			$(document).on('click','#trunk-faq a',function(){
				let eventAction = $(this).attr('data-gtm-action') ? $(this).attr('data-gtm-action') : $.trim($(this).text());
				let eventLabel = $(this).attr('data-gtm-label') ? $(this).attr('data-gtm-label') : 'FAQ';
				trunkEvent(eventLabel,eventAction);
			});

			$('#trunk-show-caraousel .product-slider').on('swipe', function(event, slick,direction){
				if (direction === 'left') {
					trunkEvent('Featured Designs', 'Swipe Left');
				} else {
					trunkEvent('Featured Designs', 'Swipe Right');	
				}
			});

			$(document).on('gtm:pdpVariationErrors', function (e, errorMsg) {
				pdpClickEvent(errorMsg,'Error Message');
			});

			$(document).on('click','.gtm-addtocartglobal', function(){
				var productName = $.trim($(this).attr('data-pdpaddtocart-name'));
				if(productName){
					shopTheLookEvent(productName,'Add All Items to Cart');
				}
			});
			
			$(document).on('search:showMore', function (e, data) {
				if ($(data.target).closest('.cyo-plp-section-view') && $(data.target).closest('.cyo-plp-section-view').length > 0) {
					cyoPlpEvent($.trim($(data.target).attr('data-category-name')), 'Load More');
				} else {
					plpEvent($.trim($(data.target).attr('data-category-name')), 'Load More');
				}
			});

			$(document).on('submit','.contactus-form form',function(){
				var formInput = $('.contactus-form form').serializeArray();
				var subjectInput =  '';
				$.each(formInput, function(i, input){
					if(input.name == 'reason'){
						subjectInput = input.value;
					}
				});
				if(subjectInput){
					contactUsEvent('Submit',subjectInput);
				}
			});

			$(document).on('click','.contactus-cta .continue-shopping',function(){
				contactUsEvent('Continue Shopping','Thank you page');
			});

			$(document).on('click','.contactus-form  .phone-link',function(){
				contactUsEvent('Telephone Call','Customer Service Hours');
			});

			$(document).on('click','.dfa-more-design a',function(){
				let eventAction = $(this).attr('data-gtm-action') ? $(this).attr('data-gtm-action') : $.trim($(this).text());
				let eventLabel = $(this).attr('data-gtm-label') ? $(this).attr('data-gtm-label') : 'FAQ';
				dfaEvent(eventLabel,eventAction);
			});

			$(document).on('click','.dfa-sign-up a',function(){
				let eventAction = $(this).attr('data-gtm-action') ? $(this).attr('data-gtm-action') : $.trim($(this).text());
				let eventLabel = $(this).attr('data-gtm-label') ? $(this).attr('data-gtm-label') : 'FAQ';
				dfaEvent(eventLabel,eventAction);
			});

			$(document).on('click','#dfa-faq .gtm-question',function(){
				let eventAction = $(this).attr('aria-expanded') == 'false' ? 'Collapse FAQs' : 'Expand FAQs';
				let eventLabel = $.trim($(this).children('p').text());
				dfaEvent(eventLabel, eventAction);
			});

			$(document).on('click','#dfa-faq a',function(){
				let eventAction = $(this).attr('data-gtm-action') ? $(this).attr('data-gtm-action') : $.trim($(this).text());
				let eventLabel = $(this).attr('data-gtm-label') ? $(this).attr('data-gtm-label') : 'FAQ';
				dfaEvent(eventLabel,eventAction);
			});

			$('#pickup-person-form').on('hidden.bs.collapse', function () {
				let eventAction = 'Collapse Alternate Pickup Person';
				let eventLabel = $.trim($(this).siblings().find('.pickup-person-title label').text());
				checkoutClickEvent(eventLabel, eventAction);
			});

			$('#pickup-person-form').on('shown.bs.collapse', function () {
				let eventAction = 'Expand Alternate Pickup Person';
				let eventLabel = $.trim($(this).siblings().find('.pickup-person-title label').text());
				checkoutClickEvent(eventLabel, eventAction);
			});
			
			$(document).on('click','.add-to-cart-upsell',function(){
				var eventLabel = $.trim($(this).attr('gtm-data-product'));
				var title = $.trim($(this).parents('.addOnProductRecommendation').find('.label_addOn').text());
				if(eventLabel){
					cartClickEvent(eventLabel, title + ' - Add to Cart');
				}
			});

			$(document).on('gtm:alternatePickupPersonIncluded', function () {
				var isPickupPerson = $('.alternate-pickup-person-wrapper').length && !$('.alternate-pickup-person-wrapper .name').hasClass('not-provided') ? 'Yes' : 'No';
				checkoutClickEvent(isPickupPerson,'Alternate Pickup Person Included');	
			});

			$(document).on('click','.gtm-cs-top-categories a',function() {
				let eventAction = $.trim($(this).parents('.gtm-cs-top-categories').children('h2').text());
				let eventLabel = $.trim($(this).text());
				customerServiceClickEvent(eventLabel,eventAction);
			});

			$(document).on('click','#helpCategoryAccordion .accordion-button',function() {
				let eventAction = '';
				if($(this).attr('aria-expanded') == 'false') {
					eventAction = $.trim('Collapse '+ $(this).parents('.service-accordion').children('h2').text());
				} else {
					eventAction = $.trim('Expand '+ $(this).parents('.service-accordion').children('h2').text());
				}
				let eventLabel = $.trim($(this).text());
				customerServiceClickEvent(eventLabel,eventAction);
			});

			$(document).on('click','#helpCategoryAccordion .accordion-body a',function() {
				let eventAction = $.trim($(this).parents('.accordion-item').find('.accordion-button').text());
				let eventLabel = $.trim($(this).text());
				customerServiceClickEvent(eventLabel,eventAction);
			});

			$(document).on('click','.contactus-options a',function() {
				let eventAction = $(this).attr('data-gtm-action') ? $(this).attr('data-gtm-action') : '';
				let eventLabel = $.trim($(this).parents('.contact-options-wrapper').find('h2').text());
				customerServiceClickEvent(eventLabel,eventAction);
			});

			$(document).on('click','.gtm-find-nearest-store a',function() {
				let eventAction = $.trim($(this).parents('.gtm-find-nearest-store').find('h2').text());
				let eventLabel = $(this).attr('data-gtm-label') ? $(this).attr('data-gtm-label') : '';
				customerServiceClickEvent(eventLabel,eventAction);
			});
		});
	}
};
module.exports = events;
